<template>
	<div class="page_goods">
		<cube-page type="Goods-view" :wurl="storeId?true:false" :backurl="storeId?'shop?store_id='+storeId:''"
			:title="isSj=='true'?'上架产品':'商品详情'">
			<div slot="content">
				<van-swipe :autoplay="3000" :indicator-color="gcfg.BackgroundColor" class="swipebox">
					<van-swipe-item v-for="(image, index) in detail.imgs_url" :key="index">
						<img v-lazy="image" />
					</van-swipe-item>
				</van-swipe>
				<van-cell-group>
					<van-cell :title="detail.goods_name" :border="false"
						style="font-size:1.2em;margin-bottom:-0.5em;font-weight: bold;" />
					<van-cell value="" title-class='titlec'>
						<template slot="icon">
							<van-icon name="discount" :color="gcfg.BackgroundColor" size="1.8em" style="margin-right:0.3em;" />
						</template>
						<template slot="title">
							<span class="van-cell-text">特价：</span>
							<van-tag mark size="large" type="danger">￥{{goods_price}} 起</van-tag>
						</template>
					</van-cell>
					<van-cell :title="'库存：'+stock_num" :value="'销量:'+detail.goods_sales" />
				</van-cell-group>
				<div class="modal_cont_box">
					<div class="til_conview">
						<van-row class='in-title'>
							<van-col>
								<van-icon name="column" :color="gcfg.BackgroundColor" size="2em" />
							</van-col>
							<van-col><span class="til_con"> 商品描述 </span></van-col>
						</van-row>
					</div>
					<div class="goods-cont-li">
						<div v-html="detail.content"></div>
					</div>
					<Copyright style="margin-bottom:4em"></Copyright>
				</div>
				<van-goods-action v-if="isSj=='true'">
					<van-goods-action-button type="danger" text="
				上架产品" @click="goSjcp" />
				</van-goods-action>
				<van-goods-action v-else>
					<van-goods-action-button type="danger" text="立即购买" @click="ByNowShow" />
				</van-goods-action>

			</div>
		</cube-page>

		<van-sku style="width: 100%;" v-model="show" :sku="sku" :goods="goods" :show-add-cart-btn="false"
			:show-soldout-sku="false" buy-text="确定" @buy-clicked="onBuyClicked" @sku-selected="skuSelected"
			@stepper-change="stepperChange">
			<template #sku-header-price="props">
				<div class="van-sku__goods-price">
					<span class="van-sku__price-symbol">￥</span>
					<span class="van-sku__price-num" v-if="!isP">{{ props.price }}</span>
					<span class="van-sku__price-num" v-else>{{ props.selectedSkuComb.price }}</span>
				</div>
			</template>
		</van-sku>
	</div>
</template>

<script>
	import CubePage from '../TP/cube-page.vue'
	import Copyright from '@/components/TP/Copyright'
	import * as util from '@/utils/network'

	export default {
		data() {
			return {
				id: this.$route.query.id,
				isSj: this.$route.query.isSj,
				store: null,
				detail: [],
				gcfg: [],
				cartnum: 0,
				addcart_loading: false,

				specData: [],
				goods_sku_id: 0, // 规格id
				goods_price: 0,
				stock_num: 0,
				line_price: 0,

				goods_num: 1, //购买数量
				goods_sales: 0, //销量

				goods_spec_arr: [], // 记录规格的数组
				sku_hidden_arr: [], // 记录不显示的sku
				min_price: '',
				show: false,
				goods: {
					// 默认商品 sku 缩略图
					picture: 'https://b.yzcdn.cn/vant/sku/shoes-1.png'
				},
				sku: {
					// 所有sku规格类目与其值的从属关系，比如商品有颜色和尺码两大类规格，颜色下面又有红色和蓝色两个规格值。
					// 可以理解为一个商品可以有多个规格类目，一个规格类目下可以有多个规格值。
					tree: [],
					// 所有 sku 的组合列表，比如红色、M 码为一个 sku 组合，红色、S 码为另一个组合
					list: [],
					price: '1.00', // 默认价格（单位元）
					stock_num: 10, // 商品总库存
				},
				isP: false,
				storeId: this.$route.query.store_id
			}
		},
		components: {
			CubePage,
			Copyright,
		},
		methods: {
			onBuyClicked() {
				this.$router.push({
					path: '/ddchecks', //ddcheck
					query: {
						goods_id: this.id,
						goods_num: this.goods_num,
						goods_sku_id: this.goods_sku_id,
						store_id: this.storeId
					}
				})
			},
			stepperChange(v) {
				this.goods_num = v
			},
			skuSelected(e) {
				let that = this;
				that.isP = false;
				let seleitem = e.selectedSkuComb
				if (e.selectedSkuComb != null) {
					let arr = that.sku.list;
					for (const elem of arr) {
						if (elem.goods_sku_id == seleitem.goods_sku_id) {
							that.isP = true
							that.sku.price = seleitem.price;
							that.stock_num = seleitem.stock_num;
							that.goods_sku_id = seleitem.goods_sku_id;
							break;
						}
					}
				}
			},
			ByNowShow() {
				//this.show=true
				this.onBuyClicked()
			},
			goSjcp() {
				let that = this;
				this.$router.push({
					path: '/sjcpxq',
					query: {
						goods_id: that.id
					}
				})
			},
			axios_Request() {
				var url = "/addons/litestore/api.goods/detail"
				let that = this;
				let id = that.storeId ? that.storeId : this.$store.getters.getShop
				//这里直接调用网络接口
				util.get(url, {
						goods_id: that.id,
						store_id: id
					},
					function(result) {
						that.goods.picture = result.data.detail.image
						that.sku.price = result.data.min_price;
						that.sku.stock_num = result.data.stock_num;
						// 初始化商品多规格
						if (result.data.detail.spec_type === '20') {
							that.sku.tree = result.data.skus.tree
							that.sku.list = result.data.skus.list
							that.line_price = result.data.line_price
							that.stock_num = result.data.stock_num
							that.goods_sales = result.data.goods_sales
							that.goods_price = result.data.min_price
						} else {
							that.goods_sku_id = result.data.detail.spec[0].spec_sku_id
							that.goods_price = result.data.detail.spec[0].goods_price
							that.line_price = result.data.detail.spec[0].line_price
							that.stock_num = result.data.detail.spec[0].stock_num
							that.goods_sales = result.data.detail.spec[0].goods_sales
						}

						//根据选择后的情况 分配sku的可选情况
						if (result.data.detail.spec_type === '20') {
							that.make_sku_showData(result.data.specData, 0);
						}

						that.detail = result.data.detail
						that.specData = result.data.specData
						that.min_price = result.data.min_price
					},
				);
			},
			/**
			 * 初始化商品多规格
			 */
			initManySpecData: function(data) {
				var that = this;
				for (let i in data.specData.spec_list) {
					if (data.specData.spec_list[i].form.stock_num >= 0) {
						var sku_id = data.specData.spec_list[i].spec_sku_id.split('_');
						//初始化 sku 显示
						//商品价格/划线价/库存
						that.goods_sku_id = data.detail.spec[i].spec_sku_id
						that.goods_price = data.detail.spec[i].goods_price
						that.line_price = data.detail.spec[i].line_price
						that.stock_num = data.detail.spec[i].stock_num

						for (let j in sku_id) {
							that.goods_spec_arr[j] = parseInt(sku_id[j]);
						}
						break;
					}
				}
				//初始化 影藏sku数组
				that.sku_hidden_arr = [];
				for (let i in data.specData.spec_list) {
					if (data.specData.spec_list[i].form.stock_num < 0) {
						that.sku_hidden_arr.push(data.specData.spec_list[i].spec_sku_id.split('_'));
					}
				}
			},
			RonChange: function(e, attr_idx) {
				let goods_spec_arr = this.goods_spec_arr

				//这里如果发现目前选项是不可选的，那么通过分配其余可选的选项
				this.make_good_sel_sku(goods_spec_arr, attr_idx);

				this.updateSpecGoods();
				this.make_sku_showData(this.specData, attr_idx);
			},
			make_good_sel_sku: function(goods_spec_arr, attr_idx) {
				var that = this;
				//首先判断此选项是否合法
				if (!that.check_good_sel_sku(goods_spec_arr)) {
					//循环sku列表 找到当前选择的第一匹配sku项目
					var spec_list = this.specData.spec_list;
					spec_list.forEach(function(value) {
						if (value.form.stock_num >= 0) {
							var sku_id_arr = value.spec_sku_id.split('_');
							sku_id_arr.forEach(function(sku_id_arrvalue, sku_id_arrindex) {
								if (sku_id_arrindex == attr_idx && goods_spec_arr[sku_id_arrindex] ==
									sku_id_arrvalue) {
									//找到目前的匹配项 可使用的sku
									goods_spec_arr = sku_id_arr;
								}
							});
						}
					});
				}
				//格式化
				goods_spec_arr.forEach(function(value, index) {
					goods_spec_arr[index] = parseInt(value);
				});

				that.goods_spec_arr = goods_spec_arr
			},
			check_good_sel_sku: function(goods_spec_arr) {
				var re_r = true;
				//影藏sku组合情况：
				var Sku_hidden = this.sku_hidden_arr;
				Sku_hidden.forEach(function(Sku_hiddenvalue) {
					//针对每个影藏sku 匹配
					var peiduiNum = 0;
					Sku_hiddenvalue.forEach(function(value, index) {
						if (value == goods_spec_arr[index]) {
							peiduiNum++;
						}
					});
					if (peiduiNum == Sku_hiddenvalue.length) {
						//发现了不合法
						re_r = false;
					}
				});
				return re_r;
			},
			/** 更新商品规格信息  */
			updateSpecGoods: function() {
				let spec_sku_id = this.goods_spec_arr.join('_');

				// 查找skuItem
				let spec_list = this.specData.spec_list,
					skuItem = spec_list.find((val) => {
						return val.spec_sku_id == spec_sku_id;
					});

				// 记录goods_sku_id
				// 更新商品价格、划线价、库存
				if (typeof skuItem === 'object') {
					this.goods_sku_id = skuItem.spec_sku_id
					this.goods_price = skuItem.form.goods_price
					this.line_price = skuItem.form.line_price
					this.stock_num = skuItem.form.stock_num
				}
			},
			make_sku_showData: function(data) {
				var that = this;
				//显示的sku数据为：
				var Showskuiteam = data.spec_attr;
				//初始化显示数据hidden为false
				Showskuiteam.forEach(function(value) {
					value.spec_items.forEach(function(value1) {
						value1.hidden = false;
					});
				});

				//循环 行规格 可选格式化，根据后面所有不变的sku规格
				Showskuiteam.forEach(function(value, index) {
					//这里 那一个选项
					//if (index != break_num) {
					that.for_eachsku_showData(Showskuiteam, index);
					//}
				});
			},
			for_eachsku_showData: function(Showskuiteam, ForNum) {
				//影藏sku组合情况：
				var Sku_hidden = this.sku_hidden_arr;
				//现在选择的情况是：
				var Nowselect = this.goods_spec_arr;

				//循环 每行规格 可选格式化，根据后面所有不变的sku规格
				Sku_hidden.forEach(function(Sku_hiddenvalue) {
					//针对每个影藏sku 匹配
					var peiduiNum = 0;
					Sku_hiddenvalue.forEach(function(value, index) {
						if (index != ForNum) {
							if (value == Nowselect[index]) {
								peiduiNum++;
							}
						}
					});
					if (peiduiNum == (Nowselect.length - 1)) {
						//此时 此sku为影藏项目
						Showskuiteam.forEach(function(Showskuiteamvalue) {
							Showskuiteamvalue.spec_items.forEach(function(value1) {
								if (value1.item_id == Sku_hiddenvalue[ForNum]) {
									value1.hidden = true;
								}
							});
						});
					}
				});
			},
		},
		created() {
			this.gcfg = this.$store.getters.getGcfg
			// this.store = this.$store.getters.getShop
			this.axios_Request();
			//这里获得购物车数量
			var url = "/addons/litestore/api.cart/getTotalNum"
			let that = this;
			let id = that.storeId ? that.storeId : this.$store.getters.getShop
			//这里直接调用网络接口
			util.get(url, {
					store_id: id
				},
				function(result) {
					that.cartnum = result.data.cart_total_num
				},
			);
		},
		watch: {
			"$store.state.gcfg"() {
				this.gcfg = this.$store.getters.getGcfg
			},
			// "$store.state.shop"() {
			// 	this.store = this.$store.getters.getShop
			// }
		},
	}
</script>


<style scoped="scoped">
	/* /deep/ .van-popup--bottom {
		margin-bottom: 0 !important;
	} */

	.swipebox {
		height: 300px;
	}

	.swipebox .van-swipe-item img {
		width: 100%;
	}

	.page_goods {
		height: 100%;
		position: absolute;
		width: 100%;
		top: 0;
		z-index: 28;
	}

	.page_goods .cube-page>.wrapper .content {
		margin: 0px;
	}

	.page_goods .van-swipe-item {
		/* height: 90vw !important; */
		/* line-height: 150px; */
	}

	.page_goods .titlec {
		font-size: 1.2em;
		color: #6d189e;
		font-weight: bold;
	}

	.page_goods .yuanjia {
		color: #666;
		text-decoration: line-through;
		margin-left: 1em;
	}

	.page_goods .modal_cont_box {
		box-sizing: border-box;
		padding: 10px 12px;
		background-color: white;
		margin-top: 1em;
	}

	.page_goods .til_conview {
		width: 100%;
		border-bottom: 1px solid #eee;
	}

	.page_goods .in-title {
		font-size: 1em;
		color: #6d189e;
		border-bottom: 2px solid #6d189e;
		width: 10em;
		display: block;
		margin: 0 auto;
		line-height: 2em;
		padding: 0em 0 0em 3em;
	}

	.page_goods .til_con {
		font-weight: bold;
		margin-left: 0.2em;
		font-size: 1.1em;
		margin-left: 0.68em;
	}

	.page_goods .tmall-types {
		margin-top: 1em;
	}

	.page_goods .tipstxt {
		font-size: 18px;
		color: rgb(88, 88, 88);
		margin-bottom: 5px;
	}

	.page_goods .radio_c {
		margin-left: -1em;
		padding-top: 0.3em;
	}

	.page_goods .radio_cc {
		display: inline;
		margin-left: 1em;
	}

	.page_goods .van-stepper__input[disabled] {
		color: white !important;
		background-color: #6d189e !important;
		z-index: -9 !important;
	}

	.goods-cont-li {
		width: 100%;
	}

	.page_goods .goods-cont-li img {
		/* max-width: 99% !important; */
		width: 100% !important;
		height: auto;
		display: block;
		margin: 0 auto;
		margin-left: 0rpx;
	}
</style>
